export default __webpack_public_path__ + "static/kontakt-3984d678f931a0ab095876e00c9ca5f6.png";